export interface TreeProjectChoice {
  projectId: number;
  probabilityLowerBound: number; // inclusive
  probabilityUpperBound: number; // exclusive
}

// Example: Each project has a 50% chance of getting picked as
// the lower bound is inclusive, and the upper bound is exclusive.
//
// const projects = [
//   {
//     projectId: 1,
//     probabilityLowerBound: 0,
//     probabilityUpperBound: 5001,
//   },
//   {
//     projectId: 2,
//     probabilityLowerBound: 5001,
//     probabilityUpperBound: 10001,
//   }
// ]
